import React from "react";
import { ChevronLeft, ChevronRight, Download, Image } from "react-feather";
import {
  Carousel,
  CarouselItem,
  CarouselIndicators,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  TabContent,
  TabPane,
  Button
} from "reactstrap";

import { carouselBasic } from "../../theme/reactstrap/carousel/CarouselSourceCode";

class LibraryCarousel extends React.Component {
  state = {
    activeTab: "1",
    activeIndex: 0
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.data !== this.props.data) {
      this.setState({
        activeTab: "1",
        activeIndex: 0
      })
    }
  }

  onExiting = () => {
    this.animating = true
  }

  onExited = () => {
    this.animating = false
  }

  next = () => {
    const { data } = this.props;
    if (this.animating) return
    const nextIndex =
      this.state.activeIndex === data.length - 1
        ? 0
        : this.state.activeIndex + 1
    this.setState({ activeIndex: nextIndex })
  }

  previous = () => {
    const { data } = this.props;
    if (this.animating) return
    const nextIndex =
      this.state.activeIndex === 0
        ? data.length - 1
        : this.state.activeIndex - 1
    this.setState({ activeIndex: nextIndex })
  }

  goToIndex = newIndex => {
    if (this.animating) return
    this.setState({ activeIndex: newIndex })
  }

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }

  render() {
    const { activeIndex } = this.state
    const height = this.props.height || "auto";
    const { 
      data,
      fileName, 
      docUrl,
      overLayControls,
      showThumbnailButton,
      showDownloadButton, 
    } = this.props;
    const slides = data.map(item => {
      return (
        <CarouselItem
          style={{height: `${height}`, textAlign: "center"}}
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.content}
        >
          <img 
            src={item.content} 
            className="img-fluid" 
            alt={item.content} 
            style={{ height: `${height}`, width: "auto", objectFit:"contain", objectPosition: "center" }} 
            />
        </CarouselItem>
      )
    })
    if(!data.length) {
      return(
        <div className="text-center">
          <h4 style={{color: "#cacaca"}}>No Preview Available !</h4>
        </div>
      )
    }
    return (
      <React.Fragment>
        <Card style={{ boxShadow: "none", border: "1px solid #eee", marginBottom: "1.5rem" }}>
          {
            fileName 
              ? <CardHeader>
                  <CardTitle>{fileName}</CardTitle>
                </CardHeader>
              : null
          }
          <CardBody style={{ padding: "1rem 1.5rem", textAlign: "center" }}>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Carousel
                  activeIndex={activeIndex}
                  next={this.next}
                  previous={this.previous}
                >
                  <CarouselIndicators
                    items={data}
                    activeIndex={activeIndex}
                    onClickHandler={this.goToIndex}
                  />
                  {slides}
                  {
                    overLayControls
                      ? <Fragment>
                        <CarouselControl
                          direction="prev"
                          directionText="Previous"
                          onClickHandler={this.previous}
                        />
                        <CarouselControl
                          direction="next"
                          directionText="Next"
                          onClickHandler={this.next}
                        />
                      </Fragment>
                      : null  
                  }
                </Carousel>
              </TabPane>
              <TabPane className="component-code" tabId="2">
                {carouselBasic}
              </TabPane>
            </TabContent>
          </CardBody>
          <CardFooter style={{ backgroundColor: "#fff", borderTop: '0px', padding: "1rem 1.5rem" }}>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                {
                  showThumbnailButton
                    ? <Button
                      outline
                      color="primary"
                      onClick={() => { this.props.changeThumbnail(data[activeIndex].url, activeIndex + 1) }}
                    >
                      Set Thumbnail
                    </Button>
                    : null
                }
                {
                  showDownloadButton
                    ? <a href={docUrl} target="_blank" download={fileName}>
                      <Button
                        outline
                        type="submit"
                        color="primary">
                        <Download className="mr-1" size={15} />Download
                      </Button>
                    </a>
                    :null
                }
               
              </div>
              <div>
                <Button
                  size="sm"
                  outline
                  color="primary"
                  onClick={this.previous} >
                  <ChevronLeft size={15} />
                </Button>
                <span className="mr-1 ml-1">{activeIndex + 1}/{data.length}</span>
                <Button
                  size="sm"
                  outline
                  color="primary"
                  onClick={this.next} >
                  <ChevronRight size={15} />
                </Button>
              </div> 
            </div>
          </CardFooter>
        </Card>
      </React.Fragment>
    )
  }
}
export default LibraryCarousel